export default {
  'DATE.JAN': 'มกราคม',
  'DATE.FEB': 'กุมภาพันธ์',
  'DATE.MAR': 'มีนาคม',
  'DATE.APR': 'เมษายน',
  'DATE.MAY': 'พฤษภาคม',
  'DATE.JUN': 'มิถุนายน',
  'DATE.JUL': 'กรกฎาคม',
  'DATE.AUG': 'สิงหาคม',
  'DATE.SEP': 'กันยายน',
  'DATE.OCT': 'ตุลาคม',
  'DATE.NOV': 'พฤศจิกายน',
  'DATE.DEC': 'ธันวาคม',

  'WEEK.SUN': 'วันอาทิตย์',
  'WEEK.MON': 'วันจันทร์',
  'WEEK.TUE': 'วันอังคาร',
  'WEEK.WED': 'วันพุธ',
  'WEEK.THU': 'วันพฤหัสบดี',
  'WEEK.FRI': 'วันศุกร์',
  'WEEK.SAT': 'วันเสาร์',

  'GENDER.MALE': 'ชาย',
  'GENDER.FEMALE': 'หญิง',
  'GENDER.OTHER': 'อื่นๆ',

  'MARRIAGE.SINGLE': 'โสด',
  'MARRIAGE.MARRIED': 'สมรส',
  'MARRIAGE.DIVORCE': 'หย่า',
  'MARRIAGE.WIDOWED': 'ม่าย',
  'MARRIAGE.SEPARATION': 'แยกกันอยู่',

  'OCCUPATION.FREELANCER': 'อาชีพอิสระ',
  'OCCUPATION.STUDENT': 'นักเรียน/นักศึกษา',
  'OCCUPATION.CONSTRUCTION': 'ก่อสร้าง',
  'OCCUPATION.FINANCE': 'การเงินและธุรกิจ',
  'OCCUPATION.AGRICULTURE': 'เกษตรกรรม',
  'OCCUPATION.EDUCATION': 'การศึกษา',
  'OCCUPATION.MEDIA': 'สื่อสารมวลชน',
  'OCCUPATION.RELIGION': 'ศาสนาและงานสังคม',
  'OCCUPATION.HOSPITALITY': 'บริการอาหารและโรงแรม',
  'OCCUPATION.TECHNOLOGY': 'เทคโนโลยีสารสนเทศ',
  'OCCUPATION.SPORTS': 'กีฬา',
  'OCCUPATION.HEALTHCARE': 'สาธารณสุข',
  'OCCUPATION.TRANSPORTATION': 'ขนส่ง',

  'INTEREST.OUTDOORS': 'กิจกรรมกลางแจ้ง',
  'INTEREST.SHOPPING': 'ช้อปปิ้งและแฟชั่น',
  'INTEREST.DINING': 'อาหารและเครื่องดื่ม',
  'INTEREST.TRAVEL': 'การท่องเที่ยว',
  'INTEREST.ENTERTAINMENT': 'ดนตรีและภาพยนตร์',
  'INTEREST.ARTS': 'ศิลปะและวัฒนธรรม',
  'INTEREST.FITNESS': 'สุขภาพและการออกกำลังกาย',
  'INTEREST.TECHNOLOGY': 'เทคโนโลยี',
  'INTEREST.LEARNING': 'การเรียนรู้และการศึกษา',
  'INTEREST.OTHERS': 'อื่นๆ',

  'DIET.CARNIVORE': 'บริโภคเนื้อสัตว์',
  'DIET.ECO_VEGETARIAN': 'มังสวิรัติรักษ์โลก',
  'DIET.RELIGIOUS_VEGETARIAN': 'มังสวิรัติเพื่อศาสนา',
  'DIET.FLEXIBLE': 'กินได้หลากหลาย',

  'TAIWAN.CITY': '',

  'EDUCATION.JUNIOR': 'ต่ำกว่ามัธยมต้น',
  'EDUCATION.SENIOR': 'มัธยมปลาย/อาชีวศึกษา',
  'EDUCATION.BACHELOR': 'ปริญญาตรี',
  'EDUCATION.MASTER': 'ปริญญาโทขึ้นไป',

  'MPS.SOURCE.8': 'แลกรหัสซีเรียล',

  'MPS.EVENT.COLLECT': 'ได้รับคะแนน',
  'MPS.EVENT.REDEEM': 'หักคะแนน',
  'MPS.EVENT.0': 'ไม่ถึงเกณฑ์การได้รับคะแนน',
  'MPS.EVENT.1': 'ครบยอดได้รับคะแนน',
  'MPS.EVENT.2': 'โบนัสวันเกิด',
  'MPS.EVENT.3': 'โบนัสสมาชิก',
  'MPS.EVENT.4': 'การให้คะแนนแบบยืดหยุ่น',
  'MPS.EVENT.5': 'โบนัสวันเกิด',
  'MPS.EVENT.6': 'โบนัสสมาชิก',
  'MPS.EVENT.7': 'เริ่มต้นให้คะแนน',
  'MPS.EVENT.8': 'ใช้จ่ายหักลดได้รับคะแนน',
  'MPS.EVENT.9': 'รับการโอน',
  'MPS.EVENT.10': 'หักคะแนนแบบยืดหยุ่น',
  'MPS.EVENT.11': 'ส่วนลดเงินสด',
  'MPS.EVENT.12': 'โบนัสจำกัดเวลา',
  'MPS.EVENT.13': 'กิจกรรมแนะนำสมาชิก',
  'MPS.EVENT.14': 'ลงทะเบียนผ่านการแนะนำ',
  'MPS.EVENT.15': 'มอบแต้มจากกิจกรรมการตลาด',
  'MPS.EVENT.16': 'มอบแต้มจากแบบสอบถามออนไลน์',
  'MPS.EVENT.17': 'แลกรหัสซีเรียล',
  'MPS.EVENT.20': 'แลกเปลี่ยน-แปลงคูปองอัตโนมัติ',
  'MPS.EVENT.21': 'แลกเปลี่ยน-เลือกคูปองอิสระ',
  'MPS.EVENT.30': 'โอนให้เพื่อน',
  'MPS.EVENT.31': 'ปรับปรุงหักคะแนน',
  'MPS.EVENT.51': 'ปรับปรุงให้คะแนน',
  'MPS.EVENT.52': 'ให้คะแนนเพิ่มเติมหลังบ้าน',
  'MPS.EVENT.53': 'ยกเลิกธุรกรรม-คืนคะแนนคูปอง',
  'MPS.EVENT.54': 'คะแนนพิเศษ',
  'MPS.EVENT.55': 'ของขวัญวันเกิด',
  'MPS.EVENT.56': 'ของขวัญเข้าร่วม',
  'MPS.EVENT.57': 'ของขวัญเลื่อนระดับ',
  'MPS.EVENT.91': 'ยกเลิกธุรกรรม-ครบยอดได้รับคะแนน',
  'MPS.EVENT.92': 'ยกเลิกธุรกรรม-โบนัสวันเกิด',
  'MPS.EVENT.93': 'ยกเลิกธุรกรรม-โบนัสสมาชิก',
  'MPS.EVENT.94': 'หักคะแนนเทียบเท่าของขวัญเลื่อนระดับ',
  'MPS.EVENT.95': 'หักคะแนนเทียบเท่าของขวัญวันเกิด',
  'MPS.EVENT.96': 'หักคะแนนเทียบเท่าคูปอง',
  'MPS.EVENT.97': 'ยกเลิกธุรกรรม-โบนัสจำกัดเวลา',
  'MPS.EVENT.99': 'คะแนนหมดอายุ',
  'MPS.EVENT.100': 'ยกเลิกรายการ - กิจกรรมการตลาด',

  'COLLECT.EVENT.0': 'ไม่ตรงตามเงื่อนไขการให้คะแนน',
  'COLLECT.EVENT.1': 'ครบยอดได้รับคะแนน',
  'COLLECT.EVENT.4': 'การให้คะแนนแบบยืดหยุ่น',
  'COLLECT.EVENT.10': 'หักคะแนนแบบยืดหยุ่น',
  'COLLECT.EVENT.20': 'แปลงคูปองอัตโนมัติ',
  'COLLECT.EVENT.21': 'เลือกคูปองอิสระ',
  'COLLECT.EVENT.90': 'ยกเลิกการสะสมคะแนน',
  'COLLECT.EVENT.91': 'ยกเลิกธุรกรรมหักคะแนน',
  'COLLECT.EVENT.92': 'ยกเลิกธุรกรรม-คืนคะแนนจากการแปลงคูปองอัตโนมัติ',
  'COLLECT.EVENT.93': 'ยกเลิกการให้คะแนน',
  'COLLECT.EVENT.94': 'ยกเลิกการหักคะแนน',
} as Record<string, any>;
